import { EyeSlash } from 'phosphor-react'

import { colors, sizes } from '@motrix/tokens'

import { PhosphorIconProps } from './interfaces'

export const EyeOff = ({
  color = colors.neutral09,
  size = '4',
  weight = 'regular',
}: PhosphorIconProps) => {
  return <EyeSlash size={sizes[size]} weight={weight} color={color} />
}
